import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/crm/leads/";

export function getLeads() {
  return http.get(apiEndpoint);
}

export function getLead(leadID) {
  return http.get(apiEndpoint + "lead-detail/" + leadID);
}

export function getLeadMasterDataAPI() {
  return http.get(apiEndpoint + "lead-master-data");
}

export function deleteLead(leadID) {
  return http.delete(apiEndpoint + "lead/" + leadID);
}

export function restoreLead(leadID) {
  return http.put(apiEndpoint + "lead/" + leadID);
}

export function saveLead(lead) {
  if (lead.ID === 0) {
    return http.post(apiEndpoint, lead);
  } else {
    return http.put(apiEndpoint, lead);
  }
}

export function getLeadSalesCards(leadID) {
  return http.get(apiEndpoint + "lead-sales-cards/" + leadID);
}

export function getLeadVisits(leadID) {
  return http.get(apiEndpoint + "lead-visits/" + leadID);
}

export function getLeadQuotations(leadID) {
  return http.get(apiEndpoint + "lead-quotations/" + leadID);
}
